import { TokenSetEvent, DefaultPublisher, getToken } from '@samc/common';
import { ref, onUnmounted } from 'vue';

/**
 * Using method meant to get a reactive version of the current user
 * 
 * @returns Will return the current user as a reactive object
 */
export const useToken = () => {
  const token = ref<string | null>(getToken());
  const subscribeEventId = DefaultPublisher
    .subscribe<TokenSetEvent>(TokenSetEvent.eventName, e => {
      token.value = e.jwt;
    });

  onUnmounted(() => {
    DefaultPublisher.unsubscribe(TokenSetEvent.eventName, subscribeEventId);
    token.value = null;
  });

  return { token };
};